import { authValidation } from "../authService";

/**
 * Validate form for OTP sending
 */
export const validateForOtp = (formData, fieldValidation) => {
  const errors = {};

  // Username validation
  if (!formData.username.trim()) {
    errors.username = "Username is required";
  } else if (fieldValidation.username.isValid === false) {
    errors.username = fieldValidation.username.message;
  }

  // Full Name validation
  if (!formData.fullName.trim()) {
    errors.fullName = "Full Name is required";
  } else if (formData.fullName.trim().length < 2) {
    errors.fullName = "Full Name must be at least 2 characters long";
  }

  // Email validation
  if (!formData.email.trim()) {
    errors.email = "Email is required";
  } else if (!authValidation.isValidEmail(formData.email)) {
    errors.email = "Please enter a valid email address";
  } else if (fieldValidation.email.isValid === false) {
    errors.email = fieldValidation.email.message;
  }

  // Password validation
  if (!formData.password) {
    errors.password = "Password is required";
  } else {
    const passwordValidation = authValidation.validatePassword(
      formData.password,
    );
    if (!passwordValidation.isValid) {
      errors.password = passwordValidation.errors[0];
    }
  }

  // Confirm password validation
  if (!formData.confirmPassword) {
    errors.confirmPassword = "Please confirm your password";
  } else if (formData.password !== formData.confirmPassword) {
    errors.confirmPassword = "Passwords do not match";
  }

  return { errors, isValid: Object.keys(errors).length === 0 };
};

/**
 * Validate complete form for submission (including OTP)
 */
export const validateCompleteForm = (formData, fieldValidation) => {
  const otpValidation = validateForOtp(formData, fieldValidation);

  if (!otpValidation.isValid) {
    return otpValidation;
  }

  const errors = {};

  // OTP validation
  if (!formData.otp.trim()) {
    errors.otp = "OTP is required";
  } else if (
    formData.otp.length !== 6 ||
    !/^[A-Za-z0-9]+$/.test(formData.otp)
  ) {
    errors.otp = "OTP must be a 6-character code";
  }

  return { errors, isValid: Object.keys(errors).length === 0 };
};
